import { jsx as _jsx } from "react/jsx-runtime";
// SPDX-License-Identifier: AGPL-3.0-only
import { Slot } from '@radix-ui/react-slot';
import { cn } from '../../lib/cn.js';
/**
 * JetBrains Mono + `tabular-nums` wrapper (the comps' `.nb-num`) — mandatory
 * for money, KPIs, IDs, timestamps, counts, connection strings. Never
 * applies locale formatting; that is the caller's job.
 */
export function MonoText({ className, asChild = false, ...props }) {
    const Comp = asChild ? Slot : 'span';
    return _jsx(Comp, { className: cn('font-mono tabular-nums', className), ...props });
}
//# sourceMappingURL=MonoText.js.map